import { getViewportSize } from ".";


export const config = {
    width: getViewportSize().width,
    height: getViewportSize().height,
    gravity: 1,
    playerSpeed: 5,
    jumpForce: -12.5,
    playerLives: 3,
    sound: {
        amp: 3.5,
        threshold: {
            // slowWalk: 0.1,
            // walk: 0.25,
            slowWalk: 0.15,
            walk: 0.35,
            // slowWalk: 0.25,
            // walk: 0.45,
            jump: 0.7,
        },
    },
};

